import { render, staticRenderFns } from "./open-page.vue?vue&type=template&id=ab50585c"
import script from "./open-page.vue?vue&type=script&lang=js"
export * from "./open-page.vue?vue&type=script&lang=js"
import style0 from "./open-page.vue?vue&type=style&index=0&id=ab50585c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports